export const translationsEN: Record<string, string> = {
  'Meta Author': 'Christos Korompokis',
  'Meta Content': 'en',
  'html lang': 'en',
  'Menu Title SSR': 'CK-Games pantomime Tik-Tak-Boom',
  'CK-Games': 'CK-Games',
  Pantomime: 'Pantomime',
  'Tik-Tak-Boom': 'Tik-Tak-Boom',
  CONTINUE: 'CONTINUE',
  BACK: 'BACK',
  'Player, it is your turn': '%0, it is your turn!',
  'Pantomime Description HTML': `
        <p>
          Gather your friend and have fun playing
          <strong> Pantomime</strong>.
        </p>
        <p>
          Pantomime is a game with a lot of fun that is included in
          <strong> CK-Games</strong>. The goal is to describe movies to your
          teamates without talking.
        </p>
        <h2>How to play Pantomime?</h2>
        <ul>
          <li>
            Create<strong> two or more teams</strong>.
          </li>
          <li>
            Choose the<strong> winning score</strong>.
            <br />
            If for instance, you choose five (5) as winning score, then, the game
            will be completed when one of the teams reaches these five wins and
            all team have played the same number of rounds. It's possible to end
            up with draw.
          </li>
          <li>
            Choose the<strong> time</strong> that every team will have available
            in order to find the required movie.
          </li>
          <li>
            Before a team starts its round, the other teams have to
            <strong> choose one (1)</strong> of the two (2) available movies
          </li>
          <li>
            When it is your team's turn to play, then one of the players of your team
            have to <strong> describe </strong> the movie that appears in the screen
            <strong> without talking</strong>.<br />
            If you find the movie, then you win a point, otherwise, sorry.
          </li>
          <li>
            When one or more teams reach the winning score, then the game ends.
          </li>
        </ul>
      `,
  'Tik-Tak-Boom Description HTML': `
        <p>
          Gather your friends and have fun playing
          <strong> Tik-Tak-Boom</strong>.
        </p>
        <p>
        Tik-Tak-Boom is a game with a lot of fun that is included in
        <strong> CK-Games</strong>. The goal is to say the appropriate
        word before bomb explodes in your hands.
        </p>
        <h2>How to play Tik-Tak-Boom?</h2>
        <ul>
          <li>Insert all players' name</li>
          <li>
            Choose the <strong> winning score</strong>
            <br />
            If for instance, you choose five (5) as winning score, then the game
            will be completed when on player reaches the five (5) wins. Dray is
            not a possible scenario.
          </li>
          <li>
            When it is your turn, you have to<strong> tell the appropriate word </strong>
            and press the button in order to pass the bomb to the next player.
            The word that you are supposed to say must include the syllable you see
            on your screen in the appropriate position. <br />
            If "Tik..." is on the screen, then the word must start with the selected syllable. <br />
            If "...Tak" is on the screen, then the word must end with the selected syllable. <br />
            If "Tik...Tak" is on the screen, then the word must just contains the selected syllable. <br />
          </li>
          <li>
            When the bomb explodes in one of the players' hands, then this player
            <strong> stops participating in the game until the round is completed</strong>.
            <br />
            The round is completed when only one player has been left and this player
            is the one that wins the point.
          </li>
          <li>
            When a player reaches the winning score, the game is completed.
          </li>
        </ul>
    `,
  Home: 'Home',
  'Team, it is your turn': '%0, it is your turn!',
  'Game Completed': 'Game Completed',
  'Restart Game': 'Restart Game',
  'Player, bomb exploded in your hands': '%0, bomb exploded in your hands!',
  'Player Setup': 'Players\' Setup',
  'Add Player': 'Add Player',
  'Next Player': 'Next Player',
  'Previous Player': 'Previous Player',
  'Tik Mode Description': 'Word must start with the selected syllable',
  'Tak Mode Description': 'Word must end with the selected syllable',
  'Tik...Tak Mode Description': 'Word must just contain the selected syllable',
  Scoreboard: 'Scoreboard',
  'Choose Winning Score': 'Choose Winning Score',
  'Tik-Tak-Boom Meta Title': 'CK-Games: Tik-Tak-Boom',
  'Tik-Tak-Boom Meta Canonical Pathname': 'en/tik-tak-boom/',
  'Tik-Tak-Boom Meta Description': 'Have fun with your friend playing Tik-Tak-Boom',
  'Tik-Tak-Boom Meta Keywords': 'game, entartainment, fun, win, lose, draw, tik-tak-boom, tik, tak, boom, bomb',
  'Choose Available Time': 'Choose Available Time',
  Seconds: 'Seconds',
  'Movie Not Found': 'Movie Not Found!',
  'Movie Found': 'Movie Found!',
  'Team, your turn completed': '%0, your turn completed!',
  'Pantomime Meta Title': 'CK-Games: Pantomime',
  'Pantomime Meta Canonical Pathname': 'en/pantomime/',
  'Pantomime Meta Description': 'Have fun with your friend playing Pantomime.',
  'Pantomime Meta Keywords': 'game, entertainment, fun, friends, company, pantomime, mime, movie, win, lose, draw',
  'Team Setup': 'Teams\' setup',
  'Add Team': 'Add Team',
  'Home Meta Title': 'CK-Games',
  'Home Meta Canonical Pathname': 'en',
  'Home Meta Description': 'You choose how you will have fun with your friends. Play Pantomime or Tik-Tak-Boom.',
  'Home Meta Keywords':
    'games, entertainment, fun, friends, company, pantomime, mime, movie, win, lose, draw, tik-tak-boom, tik, tak, boom, bomb',
  'Open Menu': 'Open Menu',
  'Close Menu': 'Close Menu'
};
